import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as types from "../../constants/actionTypes";
import * as Tools from "../../helpers/Tools";
import { logUI } from '../../api/andyliticsApi';
import moment from 'moment-timezone';
import { setTimeout } from "timers";
import * as FileSaver from 'file-saver';
import { Tooltip } from 'reactstrap';
import ToggleSwitch from "../common/input/ToggleSwitch";
import { get } from 'lodash';

class PreferenceSettings extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isContactInfoEditable: false,
            showTooltip: false,
            showCorrDataLoader: true,
            showPreferencesLoader: true,
            shouldLoadData: true,
            userAddress: null,
            userAddressObj: null,
            userPhone: null,
            userEmail: null,
            editableAddress1: null,
            editableAddress2: null,
            editableCity: null,
            editableState: null,
            editableZip: null,
            editableEmail: null,
            confirmEmail: null,
            showValidationError: false,
            validationError: "",
            showBanner: false,
            bannerMessage: "",
            isBannerSuccess: true,
            shouldSendCorrData: true,
            shouldSendPrefData: true,
            shouldSendTrigger: true,
            isFcMedicare: false,
            hasMailOption: null,
            hasNoMailOption: null
        };
        this.processUserAddress = this.processUserAddress.bind(this);
        this.processUserPhone = this.processUserPhone.bind(this);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.Preferences.ComponentDidMount", new Date(), Tools.getURLPath());
        this.componentDidUpdate(this.props);
    }

    componentDidUpdate(prevProps) {
        const { hpIdentity, isFetching, swhp } = this.props;

        if ((swhp || hpIdentity) && this.state.shouldLoadData && !isFetching) {
            let memberId = swhp ? swhp : hpIdentity.memberUserClaims.memberHccId;
            let isFcMedicare = hpIdentity ? hpIdentity.memberUserClaims.productName.includes("Medicare") : false; 
            this.setState({ shouldLoadData: false, isFcMedicare: isFcMedicare}); 
            this.props.getUserProfile(memberId);
            this.props.getUserAccountSettings();
            this.props.getEmailAddress();
        }

        if ((this.props.userProfile !== prevProps.userProfile || this.props.corrEmailAddress !== prevProps.corrEmailAddress ||(this.props.error && this.props.error !== prevProps.error)) && !this.state.shouldLoadData) {
            if (this.props.userProfile !== prevProps.userProfile) {
                this.processUserAddress();
                this.processUserPhone();
            }
            if (this.props.userProfile && this.props.corrEmailAddress !== "placeholder") {
                this.setState({ showCorrDataLoader: false, userEmail: this.props.corrEmailAddress }); 
            }
        }

        if ((this.props.notificationPreferences !== prevProps.notificationPreferences || (this.props.error && this.props.error !== prevProps.error)) && !this.state.shouldLoadData) {
            if (this.props.error && (this.props.error !== prevProps.error)) {
                this.setState({ showBanner: true, isBannerSuccess: false, bannerMessage: "Sorry, we could not process your request. Please try again later." });
            }
            else {
                this.processNotificationPreferences();
            }
            this.setState({ showPreferencesLoader: false, shouldLoadData: false });
        }

        if ((this.props.updateAddressResponse !== prevProps.updateAddressResponse || (this.props.error && this.props.error !== prevProps.error)) && !this.state.shouldSendCorrData) {
            this.setState({ showCorrDataLoader: false, shouldSendCorrData: true });
            if (this.props.error && (this.props.error !== prevProps.error)) {
                this.setState({ isContactInfoEditable: false, showBanner: true, isBannerSuccess: false, bannerMessage: "Sorry, we could not process your request. Please try again later." });
            }
            else {
                this.setState({ userEmail: this.state.editableEmail, isContactInfoEditable: false, showBanner: true, isBannerSuccess: true, bannerMessage: "Thanks, your request to update contact information has been submitted! We will review your request and your contact information will be updated in our system." });
            }
        }

        if (((this.props.paperDocument && this.props.paperDocument !== prevProps.paperDocument) || (this.props.error && this.props.error !== prevProps.error)) || (!this.state.shouldSendTrigger && this.props.paperDocument)) {
            this.setState({ showPreferencesLoader: false, shouldSendTrigger: true });
            if (this.props.error && (this.props.error !== prevProps.error)) {
                this.setState({ showBanner: true, isBannerSuccess: false, bannerMessage: "Sorry, we could not process your request. Please try again later." });
            }
            else {
                this.setState({ showBanner: true, isBannerSuccess: true, bannerMessage: "Thanks, your request has been submitted!" });
            }
        }
    }

    processNotificationPreferences() {
        var hasMailOption = [];
        var hasNoMailOption = [];

        if (this.props.notificationPreferences) {
            var preferences = this.getCamelCasing(this.props.notificationPreferences);
            var prefSelections = this.getCamelCasing(preferences.userNotificationSelections);
            prefSelections.sort((a, b) => a.notificationName > b.notificationName ? 1 : -1);

            prefSelections.forEach((pref) => {
                var camelPref = pref;
                camelPref.emailNotificationMethod = this.getCamelCasing(pref.emailNotificationMethod);
                camelPref.mailNotificationMethod = this.getCamelCasing(pref.mailNotificationMethod);
                camelPref.smsNotificationMethod = this.getCamelCasing(pref.smsNotificationMethod);

                if (pref.mailNotificationMethod) {
                    hasMailOption.push(camelPref);
                }
                else {
                    hasNoMailOption.push(camelPref);
                }
            });
        }

        this.setState({ hasMailOption: hasMailOption, hasNoMailOption: hasNoMailOption });
    }

    processUserAddress() {
        if (this.props.userProfile && this.props.userProfile.Addresses) {
            var addressString = "";

            this.props.userProfile.Addresses.map((address) => {
                if (address.Type === "Mailing") {
                    this.setState({ userAddressObj: address });
                    var address1 = address.AddressLine1 === null ? "" : address.AddressLine1;
                    var address2 = address.AddressLine2 === null ? "" : " " + address.AddressLine2;
                    var address3 = address.AddressLine3 === null ? "" : " " + address.AddressLine3;
                    addressString = address1 + address2 + address3 + ", " + address.City + ", " + address.State + " " + address.ZipCode;
                }
            });
            if (this.props.swhp && !addressString) {
                this.props.userProfile.Addresses.map((address) => {
                     if (address.Type === "Home") {
                        this.setState({ userAddressObj: address });
                        var address1 = address.AddressLine1 === null ? "" : address.AddressLine1;
                        var address2 = address.AddressLine2 === null ? "" : " " + address.AddressLine2;
                        var address3 = address.AddressLine3 === null ? "" : " " + address.AddressLine3;
                        addressString = address1 + address2 + address3 + ", " + address.City + ", " + address.State + " " + address.ZipCode;
                    }
                });
            }
            this.setState({ userAddress: addressString });
        }
    }

    processUserPhone() {
        if (this.props.userProfile) {
            var phoneString = "";
            this.props.userProfile.Addresses && this.props.userProfile.Addresses.map((address) => {
                if (address.Type === "Home") {
                    address.Telephones.map((telephone) => {
                        var areaCode = telephone.AreaCode ? telephone.AreaCode: "";
                        var number = telephone.Number ? telephone.Number : "";
                        phoneString = areaCode + "." + number;
                    });
                }
            });
            this.setState({ userPhone: phoneString });
        }
    }

    toggleTooltip() {
        this.setState({ showTooltip: !this.state.showTooltip });
    }

    submitNotificationUpdate(value, notificationName, notificationMethodName) {
        var preferences = this.getCamelCasing(this.props.notificationPreferences);
        var prefSelections = this.getCamelCasing(preferences.userNotificationSelections);
        var updatedPrefSelections = [];

        prefSelections && prefSelections.forEach((pref) => {
            var camelPref = pref;
            camelPref.emailNotificationMethod = this.getCamelCasing(pref.emailNotificationMethod);
            camelPref.mailNotificationMethod = this.getCamelCasing(pref.mailNotificationMethod);
            camelPref.smsNotificationMethod = this.getCamelCasing(pref.smsNotificationMethod);

            if (pref.notificationName === notificationName) {
                camelPref[notificationMethodName].enabled = value;

                if (value) { //if we are setting one method to true, set the others to false
                    switch (notificationMethodName) {
                        case "emailNotificationMethod":
                            camelPref.mailNotificationMethod ? camelPref.mailNotificationMethod.enabled = false: "";
                            camelPref.smsNotificationMethod ? camelPref.smsNotificationMethod.enabled = false: "";
                            break;
                        case "mailNotificationMethod":
                            camelPref.emailNotificationMethod ? camelPref.emailNotificationMethod.enabled = false : "";
                            camelPref.smsNotificationMethod ? camelPref.smsNotificationMethod.enabled = false: "";
                            break;
                        case "smsNotificationMethod":
                            camelPref.emailNotificationMethod ? camelPref.emailNotificationMethod.enabled = false : "";
                            camelPref.mailNotificationMethod ? camelPref.mailNotificationMethod.enabled = false : "";
                            break;
                        default:
                            break;
                    }
                }
            }

            updatedPrefSelections.push(camelPref);
        });

        preferences.userNotificationSelections = updatedPrefSelections;

        this.setState({ showBanner: false, showPreferencesLoader: true, shouldSendPrefData: false });

        this.props.updateUserAccountSettings(preferences);
    }

    onEditClick() {
        this.setState({
            isContactInfoEditable: true,
            initializeStateDropdown: true,
            editableAddress1: this.state.userAddressObj?.AddressLine1,
            editableAddress2: this.state.userAddressObj?.AddressLine2,
            editableCity: this.state.userAddressObj?.City,
            editableState: this.state.userAddressObj?.State,
            editableZip: this.state.userAddressObj?.ZipCode,
            editableEmail: this.state.userEmail,
            editablePhone: this.state.userPhone.replace(/\D/g, ''),
            confirmEmail: this.state.userEmail
        }, this.onStateDropdownLoad);
    }

    onStateDropdownLoad() {
        var stateDropdown = document.getElementById("notifications-state-dropdown");

        stateOptions.forEach((option) => {
            var optionHTML = document.createElement("option");
            optionHTML.text = option[0];
            optionHTML.value = option[1];
            stateDropdown.add(optionHTML, stateDropdown[0]);
        });

        this.state.editableState ? stateDropdown.value = this.state.editableState : stateDropdown.selectedIndex = -1;
    }

    submitContactInfoEdit() {
        if (this.validateInputFields() && this.state.shouldSendCorrData && this.isSaveLinkEnabled()) {
            this.setState({ showBanner: false, showCorrDataLoader: true, shouldSendCorrData: false });
            this.props.updateMemberInfo(
                this.state.editableEmail,
                this.state.editableAddress1,
                this.state.editableAddress2,
                this.state.editableCity,
                this.state.editableState,
                this.state.editableZip,
                this.state.editablePhone);
        }
    }

    isSaveLinkEnabled() {
        if ((this.state.editableAddress1 === this.state.userAddressObj?.AddressLine1
            && this.state.editableAddress2 === this.state.userAddressObj?.AddressLine2
            && this.state.editableCity === this.state.userAddressObj?.City
            && this.state.editableState === this.state.userAddressObj?.State
            && this.state.editableZip === this.state.userAddressObj?.ZipCode
            && this.state.editablePhone === this.state.userPhone.replace(/\D/g, '')
            && this.state.editableEmail === this.state.userEmail)
            || this.props.isReadOnly) {
            return false;
        }
        return true;
    }

    validateInputFields() {
        var isValid = true;
        var isAddressValid = true;
        var isPhoneNumberValid = true;
        var isEmailMatch = true;
        this.setState({ showValidationError: false, validationError: "" });

        if (!(this.state.editableEmail === this.state.confirmEmail)) {
            isValid = false;
            isEmailMatch = false;
        }
        if (!(this.state.editableAddress1 && this.state.editableCity && this.state.editableState && this.state.editableZip)) {
            isAddressValid = false;
            isValid = false;
        }

        if (!isValid) {
            var validationError = "";

            if (!isAddressValid) {
                validationError = validationError == "" ? "Please be sure to fill all Address fields, or none: Address, City, State, Zip Code." : validationError + ". Also be sure to fill all Address fields, or none: Address, City, State, Zip Code.";
            }
            if (!isPhoneNumberValid) {
                validationError = validationError == "" ? "Please be sure to enter a 10 digit phone number." : validationError + ". Also be sure to enter a 10 digit phone number.";
            }
            if (!isEmailMatch) {
                validationError = validationError == "" ? "Please be sure that both email addresses match." : validationError + ". Also be sure that both email fields match.";
            }
            this.setState({ showValidationError: true, validationError: validationError });
        }

        return isValid && isAddressValid && isPhoneNumberValid && isEmailMatch;
    }

    triggerPaperDocument(documentType) {
        var correspondenceTypeId = correspondenceTypeLookup.find((corrType) => {
            return corrType[1] === documentType;
        });
        var username = this.props.hpIdentity ? this.props.hpIdentity.username : "";
        var memberId = this.props.hpIdentity ? this.props.hpIdentity.memberUserClaims.memberHccId : this.props.swhp;
        var requestDate = new Date().toLocaleString();

        this.setState({ showBanner: false, showPreferencesLoader: true, shouldSendTrigger: false });
        this.props.triggerPaperDocument(correspondenceTypeId[0], memberId, username, requestDate);
    }

    getTooltipText(notificationName) {
        var tooltipText = null;
        if (notificationName.includes("Authorization")) {
            tooltipText = "Authorization letters will be sent to the email above. Please edit the email address if it is incorrect or add an email address.";
        }
        else if (notificationName.includes("Support")) {
            tooltipText = "Receive notifications for your Support inquiry activity.";
        }
        else if (notificationName.includes("Other")) {
            tooltipText = "\"Other communications\" may include but are not limited to communications related to enrollment, disenrollment, appeals, grievances, mid - year change notifications or notification of errors in previously released documents.";
        }
        return tooltipText;
    }

    getCamelCasing(object) {
        if (!object) {
            return null;
        }

        var newO, origKey, newKey, value;
        newO = {}
        if (object instanceof Array) {
            object = object.map((s) => {
                var newO, origKey, newKey, value;
                newO = {};

                for (origKey in s) {
                    if (s.hasOwnProperty(origKey)) {
                        newKey = (origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey).toString();
                        value = s[origKey];
                        newO[newKey] = value;
                    }
                }
                s = newO;
                return s;
            });
        }
        else {
            for (origKey in object) {
                if (object.hasOwnProperty(origKey)) {
                    newKey = (origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey).toString();
                    value = object[origKey];
                    newO[newKey] = value;
                }
            }
            object = newO;
        }
        return object;
    }

    render() {
        const { swhp } = this.props;
        const {
            showSupportTooltip, showAuthTooltip, showOtherTooltip, isSupportEmailEnabled, isSupportTextEnabled, isAuthEmailEnabled,
            isCertMailEnabled, isCertEmailEnabled, isExpMailEnabled, isExpEmailEnabled, isOthersMailEnabled, isOthersEmailEnabled,
            isProviderDirMailEnabled, isPharmacyDirMailEnabled, isFormularyMailEnabled
        } = this.state;

        return (
            <div className="container-fluid body-content hp">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <div className="preference-settings-wrapper">
                            <div className="preference-settings-container">
                                <div className="hp-title">Notifications</div>
                                <br />
                                <div className={`notification-update-banner ${this.state.showBanner ? "" : "hidden"}  ${this.state.isBannerSuccess ? "success-banner" : "failure-banner"}`}>
                                    <span className={`icon-list-check notification-update-checkmark ${this.state.isBannerSuccess ? "" : "hidden"}`}></span> {this.state.bannerMessage}
                                </div>
                                <div className="alt-background alt-background-padding">

                                    {this.state.showCorrDataLoader
                                        ?
                                        <div className="spinner">
                                            <div className="bounce1" />
                                            <div className="bounce2" />
                                            <div className="bounce3" />
                                        </div>
                                        :
                                    this.state.isContactInfoEditable
                                            ?
                                            <div className="row">
                                                <div className="col-12 notification-update-button-container">
                                                    <span className={`notification-update-save-button link-text bold-text ${this.isSaveLinkEnabled() ? "" : "disabled-text"}`} onClick={() => this.submitContactInfoEdit() }>Save</span>
                                                    <span className="notification-update-cancel-button link-text bold-text" onClick={() => this.setState({ isContactInfoEditable: false })}>Cancel</span>
                                                </div>
                                                <div className={`col-12 notification-update-validation-text ${this.state.showValidationError ? "" : "hidden"}`}>
                                                    {this.state.validationError}
                                                </div>
                                                <div className="col-12">
                                                    <div className="row notification-update-email-container">
                                                        <div className="col-12 bold-text notifications-header">
                                                            <span>Update Email Address</span>
                                                        </div>
                                                        <div className="col-md-6 col-sm-12 notifications-input-field">
                                                            <input required type="text" className="text-input" value={this.state.editableEmail || ""} onChange={(e) => { this.setState({ editableEmail: e.target.value }) }} />
                                                            <span className="floating-label">Email Address</span>
                                                        </div>
                                                        <div className="col-md-6 col-sm-12 notifications-input-field">
                                                            <input required type="text" className="text-input" value={this.state.confirmEmail || ""} onChange={(e) => { this.setState({ confirmEmail: e.target.value }) }} />
                                                            <span className="floating-label">Confirm Email Address</span>
                                                        </div>
                                                    </div>
                                                    <div className="row notification-update-address-container">
                                                        <div className="col-12 bold-text notifications-header">
                                                            <span>Update Mailing Address</span>
                                                        </div>
                                                        <div className="col-md-6 col-sm-12 notifications-input-field">
                                                            <input required type="text" className="text-input" value={this.state.editableAddress1 || ""} onChange={(e) => { this.setState({ editableAddress1: e.target.value }) }} />
                                                            <span className="floating-label">Address Line 1</span>
                                                        </div>
                                                        <div className="col-md-6 col-sm-12 notifications-input-field">
                                                            <input required type="text" className="text-input" value={this.state.editableAddress2 || ""} onChange={(e) => { this.setState({ editableAddress2: e.target.value }) }} />
                                                            <span className="floating-label">Address 2(Optional)</span>
                                                        </div>
                                                        <div className="col-lg-4 col-md-6 col-sm-12 notifications-input-field">
                                                            <input required type="text" className="text-input" value={this.state.editableCity || ""} onChange={(e) => { this.setState({ editableCity: e.target.value }) }} />
                                                            <span className="floating-label">City</span>
                                                        </div>
                                                        <div className="col-lg-4 col-md-6 col-sm-12 notifications-input-field">
                                                            <select required id="notifications-state-dropdown" onChange={(e) => { this.setState({ editableState: e.target.value }) }}></select>
                                                            <span className="floating-label">State</span>
                                                            <div className="icon-arrow-sm-down notifications-arrow-icon"></div>
                                                        </div>
                                                        <div className="col-lg-4 col-md-6 col-sm-12 notifications-input-field">
                                                            <input required type="text" className="text-input" value={this.state.editableZip || ""} onChange={(e) => { this.setState({ editableZip: e.target.value }) }} />
                                                            <span className="floating-label">Zip Code</span>
                                                            </div>
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            <div className="row">
                                                <div className="col-4">
                                                    <span className="icon-archive"></span> {this.state.userEmail ? this.state.userEmail : "Email Not Provided"}
                                                </div>
                                                <div className="col-5">
                                                    <span className="icon-location"></span> {this.state.userAddress}
                                                </div>
                                                <div className="col-1">
                                                    <div className={`link-text bold-text cursor-pointer ${swhp ||this.props.isReadOnly ? "hidden" : ""}`} onClick={() => this.onEditClick()}>Edit</div>
                                                </div>
                                            </div>
                                    }

                                </div>
                                <br />
                                {this.state.showPreferencesLoader
                                    ?
                                    <div className="spinner">
                                        <div className="bounce1" />
                                        <div className="bounce2" />
                                        <div className="bounce3" />
                                    </div>
                                    :
                                    <div className="preference-settings-switch-container">
                                        {this.state.hasNoMailOption ?
                                            this.state.hasNoMailOption.map((pref) => {
                                                return (
                                                    <div className="row" key={pref.notificationName}>
                                                        <div className="col-12 list-item-col not-linked">
                                                            <div className="row">
                                                                <div className="col-12 col-sm-4">
                                                                    <div className="list-item-col__label">{pref.notificationUiText}<span className={`icon-info ${this.getTooltipText(pref.notificationName) ? "" : "hidden"}`} id="lbl-prescriptions" />
                                                                        <Tooltip className={`${this.getTooltipText(pref.notificationName) ? "" : "hidden"}`} placement="top" isOpen={this.state.showTooltip} autohide={false} target="lbl-prescriptions" toggle={() => this.toggleTooltip()}>
                                                                            {this.getTooltipText(pref.notificationName)}
                                                                        </Tooltip>
                                                                    </div>
                                                                </div>
                                                                <div className={`col-12 col-sm-4 text-sm-right ${pref.smsNotificationMethod ? "" : "hidden"}`}>
                                                                    <ToggleSwitch placeholder="TEXT" name=""
                                                                        checked={pref.smsNotificationMethod ? pref.smsNotificationMethod.enabled : false}
                                                                        onChange={checked => this.submitNotificationUpdate(checked, pref.notificationName, "smsNotificationMethod")}
                                                                        disabled={this.props.isReadOnly}
                                                                    />
                                                                </div>
                                                                <div className={`col-12 col-sm-4 text-sm-right ${pref.mailNotificationMethod ? "" : "hidden"}`}>
                                                                    <ToggleSwitch placeholder="MAIL" name=""
                                                                        checked={pref.mailNotificationMethod ? pref.mailNotificationMethod.enabled : false}
                                                                        onChange={checked => this.submitNotificationUpdate(checked, pref.notificationName, "mailNotificationMethod")}
                                                                        disabled={this.props.isReadOnly}
                                                                    />
                                                                </div>
                                                                <div className={`col-12 col-sm-4 text-sm-right ${pref.emailNotificationMethod ? "" : "hidden"} ${this.state.userEmail ? "" : "disabled-text"}`}>
                                                                    <ToggleSwitch placeholder="EMAIL" name=""
                                                                        checked={pref.emailNotificationMethod ? pref.emailNotificationMethod.enabled : false}
                                                                        onChange={checked => this.submitNotificationUpdate(checked, pref.notificationName, "emailNotificationMethod")}
                                                                        disabled={!this.state.userEmail || this.props.isReadOnly}
                                                                    />
                                                                </div>
                                                                <div className={`col-12 col-sm-4 text-sm-right ${pref.allowOneTimePrint ? "" : "hidden"}`}>
                                                                    <input type="button" className="btn hp-button" value="One-time Print" onClick={() => this.triggerPaperDocument(pref.notificationName)} disabled={this.props.isReadOnly}></input>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                            :
                                            ""
                                        }
                                        <div className="row">
                                            <div className="col-12 list-item-col not-linked">
                                                <div className="row">
                                                    <div className="col-12 text-left">
                                                        <div className="list-item-col__info">Turn off the mail options below to save paper and find what you need in the member portal instead.</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {this.state.hasMailOption ?
                                            this.state.hasMailOption.map((pref) => {
                                                return (
                                                    <div className="row" key={pref.notificationName}>
                                                        <div className="col-12 list-item-col not-linked">
                                                            <div className="row">
                                                                <div className="col-12 col-sm-4">
                                                                    <div className="list-item-col__label">{pref.notificationUiText}<span className={`icon-info ${this.getTooltipText(pref.notificationName) ? "" : "hidden"}`} id="lbl-prescriptions" />
                                                                        <Tooltip className={`${this.getTooltipText(pref.notificationName) ? "" : "hidden"}`} placement="top" isOpen={this.state.showTooltip} autohide={false} target="lbl-prescriptions" toggle={() => this.toggleTooltip()}>
                                                                            {this.getTooltipText(pref.notificationName)}
                                                                        </Tooltip>
                                                                    </div>
                                                                </div>
                                                                <div className={`col-12 col-sm-4 text-sm-right ${pref.smsNotificationMethod ? "" : "hidden"}`}>
                                                                    <ToggleSwitch placeholder="TEXT" name=""
                                                                        checked={pref.smsNotificationMethod ? pref.smsNotificationMethod.enabled : false}
                                                                        onChange={checked => this.submitNotificationUpdate(checked, pref.notificationName, "smsNotificationMethod")}
                                                                        disabled={this.props.isReadOnly}
                                                                    />
                                                                </div>
                                                                <div className={`col-12 col-sm-4 text-sm-right ${pref.mailNotificationMethod ? "" : "hidden"}`}>
                                                                    <ToggleSwitch placeholder="MAIL" name=""
                                                                        checked={pref.mailNotificationMethod ? pref.mailNotificationMethod.enabled : false}
                                                                        onChange={checked => this.submitNotificationUpdate(checked, pref.notificationName, "mailNotificationMethod")}
                                                                        disabled={this.props.isReadOnly}
                                                                    />
                                                                </div>
                                                                <div className={`col-12 col-sm-4 text-sm-right ${pref.emailNotificationMethod ? "" : "hidden"} ${this.state.userEmail ? "" : "disabled-text"}`}>
                                                                    <ToggleSwitch placeholder="EMAIL" name=""
                                                                        checked={pref.emailNotificationMethod ? pref.emailNotificationMethod.enabled : false}
                                                                        onChange={checked => this.submitNotificationUpdate(checked, pref.notificationName, "emailNotificationMethod")}
                                                                        disabled={!this.state.userEmail || this.props.isReadOnly}
                                                                    />
                                                                </div>
                                                                <div className={`col-12 col-sm-4 text-sm-right ${pref.allowOneTimePrint ? "" : "hidden"}`}>
                                                                    <input type="button" className="btn hp-button" value="One-time Print" onClick={() => this.triggerPaperDocument(pref.notificationName)}></input>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                            :
                                            ""
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

const stateOptions = [["ALABAMA", "AL"], ["ALASKA", "AK"], ["AMERICAN SAMOA", "AS"], ["ARIZONA", "AZ"], ["ARKANSAS", "AR"]
    , ["CALIFORNIA", "CA"], ["COLORADO", "CO"], ["CONNECTICUT", "CT"], ["DELAWARE", "DE"], ["DISTRICT OF COLUMBIA", "DC"]
    , ["FLORIDA", "FL"], ["GEORGIA", "GA"], ["GUAM", "GU"], ["HAWAII", "HI"], ["IDAHO", "ID"]
    , ["ILLINOIS", "IL"], ["INDIANA", "IN"], ["IOWA", "IA"], ["KANSAS", "KS"], ["KENTUCKY", "KY"]
    , ["LOUISIANA", "LA"], ["MAINE", "ME"], ["MARYLAND", "MD"], ["MASSACHUSETTS", "MA"], ["MICHIGAN", "MI"]
    , ["MINNESOTA", "MN"], ["MISSISSIPPI", "MS"], ["MISSOURI", "MO"], ["MONTANA", "MT"], ["NEBRASKA", "NE"]
    , ["NEVADA", "NV"], ["NEW HAMPSHIRE", "NH"], ["NEW JERSEY", "NJ"], ["NEW MEXICO", "NM"], ["NEW YORK", "NY"]
    , ["NORTH CAROLINA", "NC"], ["NORTH DAKOTA", "ND"], ["NORTHERN MARIANA IS", "MP"], ["OHIO", "OH"], ["OKLAHOMA", "OK"]
    , ["OREGON", "OR"], ["PENNSYLVANIA", "PA"], ["PUERTO RICO", "PR"], ["RHODE ISLAND", "RI"], ["SOUTH CAROLINA", "SC"]
    , ["SOUTH DAKOTA", "SD"], ["TENNESSEE", "TN"], ["TEXAS", "TX"], ["UTAH", "UT"], ["VERMONT", "VT"], ["VIRGINIA", "VA"]
    , ["VIRGIN ISLANDS", "VI"], ["WASHINGTON", "WA"], ["WEST VIRGINIA", "WV"], ["WISCONSIN", "WI"], ["WYOMING", "WY"]];

const correspondenceTypeLookup = [[3, "COC/EOC"], [6, "Formulary"], [5, "Pharmacy Directory"], [4, "Provider Directory"]];

const mapStateToProps = (state, ownProps) => {
    return {
        error: state.healthPlanServices.error,
        hpIdentity: state.session.healthPlanUserProfile,
        isFetching: state.healthPlanServices.isFetching,
        swhp: state.domain.hi,
        userProfile: state.healthPlanServices.userProfile,
        notificationPreferences: state.healthPlanServices.notificationPreferences,
        notificationPreferenceUpdate: state.healthPlanServices.notificationPreferenceUpdate,
        updateAddressResponse: state.healthPlanServices.updateAddressResponse,
        paperDocument: state.healthPlanServices.paperDocument,
        corrEmailAddress: state.healthPlanServices.corrEmailAddress,
        ...ownProps
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getUserProfile: (memberId) => dispatch({ type: types.HP_GET_PROFILE_START, memberId: memberId }),
        getUserAccountSettings: () => dispatch({ type: types.HP_GET_NOTIFICATION_PREFERENCES_START }),
        updateMemberInfo: (email, address1, address2, city, state, zip, phone) => dispatch({ type: types.HP_UPDATE_MEMBER_ADDRESS_START, email: email, address1: address1, address2: address2, city: city, state: state, zip: zip, phone: phone }),
        updateUserAccountSettings: (requestBody) => dispatch({ type: types.HP_UPDATE_NOTIFICATION_PREFERENCES_START, requestBody: requestBody }),
        triggerPaperDocument: (correspondenceTypeId, memberId, username, requestDate) => dispatch({ type: types.HP_TRIGGER_PAPER_DOCUMENT_START, correspondenceTypeId: correspondenceTypeId, memberId: memberId, username: username, requestDate: requestDate }),
        getEmailAddress: () => dispatch({ type: types.HP_GET_CORR_EMAIL_ADDRESS_START }),
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PreferenceSettings));
